import React from "react";
import SideBar from "./SideBar";
import img7 from "../../Images/Gallrey/Pic7.jpeg";
import img6 from "../../Images/Gallrey/Pic6.jpeg";
import img5 from "../../Images/Gallrey/Pic5.jpeg";
import img4 from "../../Images/Gallrey/Pic4.jpeg";
import img3 from "../../Images/Gallrey/Pic3.jpeg";
import img2 from "../../Images/Gallrey/Pic2.jpeg";
import img1 from "../../Images/Gallrey/Pic1.jpeg";
import $ from "jquery";

const handlePrev = () => {
  var prev = $("#carouselExampleControls");
  var ans = prev.carousel("prev");
  return ans;
};

const handleNext = () => {
  var next = $("#carouselExampleControls");
  console.log(next);
  var ans = next.carousel("next");
  return ans;
};

const GroupPhotos = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar groupPhotos={true} />
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Group Photos </div>
          <hr />
          <div className="d-flex justify-content-center mb-5">
          <div
            id="carouselExampleControls"
            className="carousel slide width-600"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner gallery">
              <div className="carousel-item active">
              <img src={img7} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">
              <img src={img6} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">                
                <img src={img5} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={img4} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={img3} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={img2} className="d-block" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={img1} className="d-block" alt="..." />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
          </div>

          {/* <div className="row pt-2">
            <div className="col-lg-6">
              <div className="card remove-border d-flex align-items-center mb-4 gallery">
              <img className="mb-3" src={img1} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card remove-border d-flex align-items-center mb-4 gallery">
              <img className="mb-3" src={img2} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card remove-border d-flex align-items-center mb-4 gallery">
              <img className="mb-3" src={img3} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card remove-border d-flex align-items-center mb-4 gallery">
              <img className="mb-3" src={img4} />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card remove-border d-flex align-items-center mb-4 gallery">
              <img className="mb-3" src={img5} />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default GroupPhotos;
